import { memo } from 'react';
import StatefulField from './StatefulField';

const ConfirmPasswordField = ({ confirmPassword, setConfirmPassword, isConfirmPassValid }) => {
	const hint = !isConfirmPassValid && 'Passwörter stimmen nicht überein!';

	return (
		<StatefulField
			id='confirm-password'
			type='password'
			isRequired={true}
			autoComplete='new-password'
			label='Passwort erneut eingeben'
			placeholder='Bitte geben Sie das neue Passwort erneut ein.'
			value={confirmPassword}
			updateValue={setConfirmPassword}
			validator={isConfirmPassValid}
			hint={hint}
		/>
	);
};

export default memo(ConfirmPasswordField);
